export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/noMajorAccidents.03ade9c7.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};